module.exports = __webpack_public_path__ + "assets/img/25_341.1e0f42d2.jpg";